<template>
  <div class="flex flex-wrap flex-card-container">
    <div
      v-for="(info, index) in section.list"
      :key="index"
      class="item"
    >
      <DestinationImageCard
        :card-info="info"
        :index="index"
        @click="handleCardClick(info)"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  section: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['card-click'])

const handleCardClick = (item) => {
  emit('card-click', item)
}
</script>

<style lang="scss" scoped>
.flex-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: theme('screens.lg')) {
    justify-content: center;
    .item {
      flex: 1 0 calc(100% / 3 - 1rem); //3 cards per row
    }
  }

  @media (max-width: theme('screens.md')) {
    justify-content: center;
    .item {
      flex: 1 0 100%; // 1 item per row on mobile
      margin: auto;
    }
  }
}
</style>